import React, { useState, useEffect } from "react";
import { Box } from "@bca/ui-library";
import throttle from 'lodash.throttle';
import { ViewportSizeType } from "../hooks/useViewport.hook";
import BackToTopButton from "../common/components/BackToTopButton";

const BackToTopButtonMechanism:React.FC<{
  cardPosition: Number;
  selectedVehicles: string[];
  viewportWidth: ViewportSizeType;
}> = ({cardPosition, selectedVehicles, viewportWidth}) => {

  const [displayButton, setDisplayButton] = useState<Boolean>(false);
  const [directionUp, setDirectionUp] = useState<Boolean>(true);

  useEffect(()=>{
    (window.scrollY > cardPosition && directionUp) ? setDisplayButton(true) : setDisplayButton(false);
  },[directionUp, cardPosition]);

  useEffect(() => {

    let oldValue = 0;
    let newValue = 0;

    const handleScroll = () => {
      newValue = window.pageYOffset;
      
      if (oldValue < newValue) {
        newValue < cardPosition && setDisplayButton(false);
        setDirectionUp(false);
      } else if (oldValue > newValue) {
        newValue < cardPosition && setDisplayButton(false);
        setDirectionUp(true);
      }

      oldValue = newValue;
    }

    const throttledScroll = throttle(handleScroll, 500);
    document.addEventListener('scroll', throttledScroll);

    // Clear the scroll event listener
    return () => {
      document.removeEventListener('scroll', throttledScroll);
    };
  }, [cardPosition]);

 const boxStyling = () => {
  return Boolean(selectedVehicles.length > 0) 
   ?  `opacity: 1;
      z-index: 10;
      position: fixed;
      right:0;
      bottom: ${viewportWidth === 'mobile' || viewportWidth === 'tablet' ? 134 : 114}px;
      &.hideButton {
        opacity: 0;
        transition: opacity 0.5s;
      }
      &.displayButton { 
        opacity: 1;
        transition: opacity 0.7s;
      }
      `
   :  `opacity: 1;
      z-index: 10;
      position: fixed;
      bottom: 16px;
      right:0;
      &.hideButton {
        opacity: 0;
        transition: opacity 0.5s;
      }
      &.displayButton {
        opacity: 1;
        transition: opacity 0.7s;
      }`
   }

  return(
      <>
        <Box css={boxStyling()} className={displayButton? 'displayButton':'hideButton'}>
          <BackToTopButton />
        </Box>
     </>
    )
  }

  export default BackToTopButtonMechanism;